/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkSearchResultDto } from '../models/work-search-result-dto';

@Injectable({ providedIn: 'root' })
export class WorkSearchService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `searchV1ControllerSearch()` */
  static readonly SearchV1ControllerSearchPath = '/v1/search/search/{keyword}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchV1ControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchV1ControllerSearch$Response(
    params: {
      keyword: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSearchResultDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkSearchService.SearchV1ControllerSearchPath, 'get');
    if (params) {
      rb.path('keyword', params.keyword, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSearchResultDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchV1ControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchV1ControllerSearch(
    params: {
      keyword: string;
    },
    context?: HttpContext
  ): Observable<WorkSearchResultDto> {
    return this.searchV1ControllerSearch$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSearchResultDto>): WorkSearchResultDto => r.body)
    );
  }

}
